export const CHAT_EMOJIS: string[] = [
  "😊",
  "😂",
  "🤣",
  "😍",
  "🥰",
  "😘",
  "😉",
  "😎",
  "🤔",
  "🙄",
  "😴",
  "🤤",
  "😴",
  "🥱",
  "😵",
  "🤯",
  "🔥",
  "💯",
  "👍",
  "👎",
  "👌",
  "✌️",
  "🤞",
  "🤝",
  "💪",
  "🙏",
  "👏",
  "🤦",
  "🤷",
  "💀",
  "👻",
  "🎉",
  "❤️",
  "💔",
  "💕",
  "💖",
  "💗",
  "💘",
  "💙",
  "💚",
  "🚀",
  "⭐",
  "🌟",
  "💎",
  "💰",
  "🍀",
  "🎯",
  "🏆",
];
